import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const CreditrequestAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		fullname: yup.string().required().label($t('fullname')),
		mobile: yup.string().required().label($t('mobile')),
		pan_card: yup.string().required().label($t('panCard')),
		report_type: yup.string().required().label($t('reportType')),
		gender: yup.string().required().label($t('gender')),
		dob: yup.string().required().label($t('dob')),
		address: yup.string().required().label($t('address')),
		state: yup.string().required().label($t('state')),
		pincode: yup.string().required().label($t('pincode')),
		consent: yup.string().required().label($t('consent')),
		userid: yup.number().nullable().label($t('userid'))
	});
	
	//form default values
	const formDefaultValues = {
		fullname: '', 
		mobile: '', 
		pan_card: '', 
		report_type: '', 
		gender: '', 
		dob: new Date(), 
		address: '', 
		state: '', 
		pincode: '', 
		consent: "(N'Y", 
		userid: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/creditrequest`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="CreditrequestAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewCreditRequest')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobile')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobile"  onChange={formik.handleChange}  value={formik.values.mobile}   label={$t('mobile')} type="text" placeholder={$t('enterMobile')}        className={inputClassName(formik?.errors?.mobile)} />
                                                <ErrorMessage name="mobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('panCard')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pan_card"  onChange={formik.handleChange}  value={formik.values.pan_card}   label={$t('panCard')} type="text" placeholder={$t('enterPanCard')}        className={inputClassName(formik?.errors?.pan_card)} />
                                                <ErrorMessage name="pan_card" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('reportType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="report_type"  onChange={formik.handleChange}  value={formik.values.report_type}   label={$t('reportType')} type="text" placeholder={$t('enterReportType')}        className={inputClassName(formik?.errors?.report_type)} />
                                                <ErrorMessage name="report_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.gender.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="gender" value={option.value} onChange={formik.handleChange}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dob" showButtonBar className={inputClassName(formik?.errors?.dob)} dateFormat="yy-mm-dd" value={formik.values.dob} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address"  onChange={formik.handleChange}  value={formik.values.address}   label={$t('address')} type="text" placeholder={$t('enterAddress')}        className={inputClassName(formik?.errors?.address)} />
                                                <ErrorMessage name="address" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('state')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="state"  onChange={formik.handleChange}  value={formik.values.state}   label={$t('state')} type="text" placeholder={$t('enterState')}        className={inputClassName(formik?.errors?.state)} />
                                                <ErrorMessage name="state" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pincode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pincode"  onChange={formik.handleChange}  value={formik.values.pincode}   label={$t('pincode')} type="text" placeholder={$t('enterPincode')}        className={inputClassName(formik?.errors?.pincode)} />
                                                <ErrorMessage name="pincode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('consent')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="consent"  onChange={formik.handleChange}  value={formik.values.consent}   label={$t('consent')} type="text" placeholder={$t('enterConsent')}        className={inputClassName(formik?.errors?.consent)} />
                                                <ErrorMessage name="consent" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any"    className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
CreditrequestAddPage.defaultProps = {
	primaryKey: 'requestid',
	pageName: 'creditrequest',
	apiPath: 'creditrequest/add',
	routeName: 'creditrequestadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default CreditrequestAddPage;
